export default __webpack_public_path__ + "static/media/give50backdrop.eca9e289.jpeg";